import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.join";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { FormattedTime, FormattedDate, FormattedMessage } from 'react-intl';
import { Link } from 'react-router';
import { StarRating } from 'components/StarRating/StarRating';
import { interpolate } from 'helpers/interpolate';
import { deepExtract } from 'helpers/deep';
import { nextMidnight } from 'components/CountdownTimer/CountdownTimer';
import { OfferExpiryCountdown } from './OfferExpiryCountdown';
export var stringSeparatedWords = function stringSeparatedWords(separator) {
  for (var _len = arguments.length, words = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    words[_key - 1] = arguments[_key];
  }

  return (// remove all undefined words
    words.filter(Boolean) // combine all words using the seperator
    .join(separator)
  );
};
export var ClassAvailable =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ClassAvailable, _PureComponent);

  function ClassAvailable() {
    _classCallCheck(this, ClassAvailable);

    return _possibleConstructorReturn(this, _getPrototypeOf(ClassAvailable).apply(this, arguments));
  }

  _createClass(ClassAvailable, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          ctaText = _this$props.ctaText,
          displayName = _this$props.displayName,
          legal = _this$props.legal,
          purchaseUrl = _this$props.purchaseUrl,
          schedule = _this$props.schedule,
          subtitle = _this$props.subtitle,
          title = _this$props.title;
      var venue = deepExtract('venue', schedule, {});
      var venueAddress = deepExtract('address', venue, {});
      var interpolationConfig = {
        $USER_NAME: displayName,
        $VENUE_NAME: deepExtract('name', venue, '')
      };
      var classStartTime = schedule.starttime * 1000;
      var promoTitle = interpolate(title, interpolationConfig);
      var promoSubtitle = interpolate(subtitle, interpolationConfig);
      var ratings = venue.ratings;
      var imageUrl = deepExtract('images.default', venue, undefined);
      var venueNameAndAlias = stringSeparatedWords(' • ', venue.name, deepExtract('location.name', venue));
      var classAdressLine1 = stringSeparatedWords(', ', venueAddress.address_line1, venueAddress.address_line2);
      var classAdressLine2 = stringSeparatedWords(', ', venueAddress.city, venueAddress.state, venueAddress.zip_code);
      var nextMidnightTime = nextMidnight();
      var countdownTo = nextMidnightTime > classStartTime ? classStartTime : nextMidnightTime;
      return React.createElement("section", {
        className: "class-available"
      }, React.createElement("p", {
        className: "class-available__mobile-title"
      }, promoTitle), React.createElement("div", {
        className: "class-available__class-detail"
      }, React.createElement("img", {
        src: imageUrl,
        alt: "venue"
      }), React.createElement("div", {
        className: "class-available__class-detail__content"
      }, React.createElement("h3", {
        className: "epsilon mb-"
      }, schedule.class.name), React.createElement("div", {
        className: "color-text-light mb"
      }, venueNameAndAlias, React.createElement("br", null), !!ratings && React.createElement(StarRating, {
        rating: ratings.mean,
        showRatingNumber: true
      })), React.createElement("p", {
        className: "color-text-light"
      }, React.createElement(FormattedMessage, {
        id: "inviteafriend.day-and-time",
        defaultMessage: "{classDay}, {classDate} at {classTime}",
        values: {
          classDay: React.createElement(FormattedDate, {
            weekday: "long",
            value: classStartTime
          }),
          classDate: React.createElement(FormattedDate, {
            day: "numeric",
            month: "short",
            value: classStartTime
          }),
          classTime: React.createElement(FormattedTime, {
            value: classStartTime,
            hour: "numeric",
            minute: "numeric"
          })
        }
      }), React.createElement("br", null), classAdressLine1, React.createElement("br", null), classAdressLine2))), React.createElement("div", {
        className: "class-available__promo"
      }, React.createElement("div", {
        className: "class-available__promo__offer"
      }, React.createElement("h2", {
        className: "class-available__promo__offer__header mb"
      }, promoTitle), !!subtitle && React.createElement("p", {
        className: "class-available__promo__offer__subtitle"
      }, promoSubtitle)), React.createElement("div", null, React.createElement(Link, {
        to: purchaseUrl,
        className: "class-available__promo__cta bt bt--primary mb-"
      }, ctaText)), !!legal && React.createElement("p", {
        className: "class-available__promo__legal color-text-light text--sm"
      }, legal), React.createElement(OfferExpiryCountdown, {
        countdownTo: countdownTo
      })));
    }
  }]);

  return ClassAvailable;
}(PureComponent);
ClassAvailable.propTypes = {
  ctaText: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  legal: PropTypes.string,
  purchaseUrl: PropTypes.string.isRequired,
  schedule: PropTypes.object,
  subtitle: PropTypes.string,
  title: PropTypes.string.isRequired
};